import { bl_fi_my_einvoice_batch_pool_cycle_run_hdr_RowClass } from '../../dbschema/bl_fi_my_einvoice_batch_pool_cycle_run_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class BatchPoolCycleRunContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_batch_pool_cycle_run_hdr: bl_fi_my_einvoice_batch_pool_cycle_run_hdr_RowClass = new bl_fi_my_einvoice_batch_pool_cycle_run_hdr_RowClass();
}
